// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import moment from 'moment'
import router from './router'
import store from './store'

Vue.config.productionTip = false
Vue.prototype.$user = store.state.settings.user

Vue.filter('number', function (value) {
  if (value || value == 0)
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  else
    return ''
})

Vue.filter('date', function (value) {
  if (value)
    return moment(value).format('DD MMM Do YYYY')
  else
    return ''
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js